import React, {useCallback} from "react";
import ReactDocumentTitle from "~/components/ReactDocumentTitle";
import UIButton from "~/old-ui/UIButton";
import {createUseStyles} from "react-jss";
import {reverse} from "~/urls";
import ReactLink from "~/components/ReactLink";
import useCookie from "~/hooks/useCookie";

export default function DevSettingsScene() {
  const classes = useStyles();

  const [v, setV] = useCookie('_use');
  const setDev = useCallback(() => setV('dev'), []);
  const resetV = useCallback(() => setV(null), []);

  return (
    <>
      <ReactDocumentTitle title='Settings'/>

      <div className={classes.container}>
        <h1>Settings</h1>
        <h3>Select frontend version</h3>

        <div className={classes.row}>
          <UIButton primary={v !== 'dev'} className={classes.btn} onClick={resetV}>default</UIButton>

          <UIButton primary={v === 'dev'}  className={classes.btn} onClick={setDev}>dev</UIButton>
        </div>

        <div className={classes.bottom}>
          <ReactLink to={reverse('dev:index')}>back to index</ReactLink>
        </div>
      </div>
    </>
  )
}


const useStyles = createUseStyles({
  container: {
    padding: [[0, 20]],
  },

  btn: {
    width: 84,

    '& + &': {
      marginLeft: 16,
    }
  },

  row: {
    display: 'flex',
  },

  bottom: {
    marginTop: 24,
  }
});
